import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import miscHelper from 'general/helpers/miscHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

DialogChargeInventoryAddView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogChargeInventoryAddView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const editMode = !!item;
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [avatarFile, setAvatarFile] = useState(null);
    const [avatar, setAvatar] = useState('');
    const [name, setName] = useState('');
    const [price, setPrice] = useState('');
    const [selectedChargeBrand, setSelectedChargeBrand] = useState(null);
    const [unit, setUnit] = useState('');
    const [description, setDescription] = useState('');
    useEffect(() => {
        if (item) {
            setAvatar(item.images);
            setName(item.name);
            setPrice(item.price);
            setDescription(item.description);
            setUnit(item.unit);
            setSelectedChargeBrand({
                id: item?.chargeBrand?.brandId,
                name: item?.chargeBrand?.name,
                item: item?.chargeBrand,
            });
        }
    }, [item]);

    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (
            !Utils.isValid(avatar) ||
            !Utils.isValid(name) ||
            !Utils.isValid(price) ||
            !Utils.isValid(unit)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        if (Utils.isValid(price) && price <= 0) {
            ToastHelper.showError('Giá sản phẩm phải lớn hơn 0');
            return;
        }
        let params = {
            name,
            brandId: selectedChargeBrand?.id ?? '',
            price,
            unit,
            description,
        };
        if (avatarFile) {
            const res = await miscHelper.callApiUploadFile(avatarFile);
            if (_.isArray(res) && res.length > 0) {
                params.images = res[0].relativePath;
            }
        }
        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
        setLoading(true);
        if (!editMode) {
            const res = await ChargeHelper.API.requestCreateChargeInventoryCategory(params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Thêm mới sản phẩm thành công');
                onDone && onDone();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        } else {
            const res = await ChargeHelper.API.requestUpdateChargeInventoryCategory(item.categoryId, params);
            if (_.isBoolean(res) && res) {
                ToastHelper.showSuccess('Chỉnh sửa thông tin sản phẩm thành công');
                onDone && onDone();
            } else if (_.isString(res)) {
                ToastHelper.showError(res);
            }
        }
        setLoading(false);
    };

    const dropdownChargeBrandEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="brandId_dialog"
                name="brandId_dialog"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between`}
                        type="button"
                    >
                        {selectedChargeBrand?.name ?? 'Chọn hãng sản xuất'}
                    </button>
                }
                selectedValue={selectedChargeBrand}
                dropdownMenuItems={[{ name: 'Hãng sản xuất', role: 'CHARGE_BRAND' }]}
                getSubItems={async (item) => {
                    return ChargeHelper.API.requestGetChargeBrandList({
                        page: item?.page || 0,
                        limit: 10,
                        q: item?.q || '',
                    }).then((data) => {
                        return {
                            values: data.brands?.map((row) => ({
                                id: row?.brandId,
                                name: row?.name,
                                item: row,
                            })),
                            total: data.total,
                        };
                    });
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedChargeBrand(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                defaultValue={{
                    name: 'Hãng sản xuất',
                    role: 'CHARGE_BRAND',
                }}
                footerEl={
                    <div
                        className="p-4 position-sticky sticky-bottom bg-white"
                        style={{
                            borderTop: `1px solid ${AppColors.gray[300]}`,
                        }}
                    >
                        {UIHelper.buildNegativeButton('Bỏ chọn', () => {
                            setSelectedChargeBrand(null);
                        })}
                    </div>
                }
            />
        );
    }, [selectedChargeBrand, readyToValidate]);

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* avatar */}
                <div className="col-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Ảnh sản phẩm', true)}
                    <div className="row m-0 p-0">
                        <div className="col-lg-3 col-md-4 col-6 p-0">
                            <KTImageInput
                                fullWidth={true}
                                aspectRatio={'1'}
                                name="avatar"
                                editable={true}
                                value={Utils.isValid(avatar) ? Utils.getFullUrl(avatar) : null}
                                acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                                defaultImage={
                                    AppResource.images.chargeConnectorTypes.imgChargeStationBgDefault
                                }
                                onSelectedFile={(file) => {
                                    setAvatarFile(file);
                                    const imageUrl = URL.createObjectURL(file);
                                    setAvatar(imageUrl);
                                }}
                                onRemovedFile={() => {
                                    setAvatarFile(null);
                                    setAvatar('');
                                }}
                                enableCheckValid={readyToValidate}
                                isValid={Utils.isValid(avatar)}
                                isTouched={readyToValidate}
                                feedbackText="Ảnh sản phẩm không hợp lệ"
                            />
                        </div>
                        <div className='p-0'>
                            Định dạng: JPG, PNG
                        </div>
                    </div>
                </div>
                {/* name */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Tên sản phẩm', true)}
                    <KTFormInput
                        type={KTFormInputType.text}
                        placeholder="Nhập tên sản phẩm"
                        name="name"
                        value={name}
                        onChange={(value) => {
                            setName(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(name)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(name) ? "Tên sản phẩm không hợp lệ" : ''}
                    />
                </div>
                {/* brandId */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Hãng sản xuất')}
                    {dropdownChargeBrandEl}
                </div>
                {/* price */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Đơn giá (giá bán)', true)}
                    <KTFormInput
                        type={KTFormInputType.currency}
                        unit='VNĐ'
                        placeholder="Nhập giá sản phẩm"
                        name="price"
                        value={price}
                        onChange={(value) => {
                            setPrice(value);
                        }}
                        enableCheckValid={readyToValidate}
                        isValid={
                            Utils.isValid(price) && price > 0
                        }
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && (!Utils.isValid(price) || price <= 0) ? "Giá sản phẩm phải lớn hơn 0" : ''}
                    />
                </div>
                {/* unit */}
                <div className="col-md-6 mb-4 px-2">
                    {UIHelper.buildFormLabel('Đơn vị tính', true)}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'button-invalid' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    ChargeHelper.Data.inventoryUnitOptions,
                                    (item) => item.value === unit
                                )?.name ?? 'Chọn đơn vị tính'}
                            </button>
                        )}
                        selectedValue={unit}
                        dropdownMenuItems={ChargeHelper.Data.inventoryUnitOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setUnit(value)}
                        enableCheckValid
                        isDropdownForm={true}
                        isValid={Utils.isValid(unit)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(unit) ? "Đơn vị tính không hợp lệ" : ''}
                    />
                </div>
                {/* description */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Mô tả')}
                    <KTFormTextArea
                        placeholder="Nhập mô tả"
                        rows={3}
                        name="description"
                        value={description}
                        onChange={(value) => {
                            setDescription(value);
                        }}
                        enableCheckValid={false}
                    />
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    !editMode ? 'Thêm' : 'Cập nhật',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogChargeInventoryAddView;
